import { render, staticRenderFns } from "./LicenceModel.vue?vue&type=template&id=5b5be235&"
import script from "./LicenceModel.vue?vue&type=script&lang=js&"
export * from "./LicenceModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports